import { render, staticRenderFns } from "./CollectionView.vue?vue&type=template&id=5dab0192&scoped=true&"
import script from "./CollectionView.vue?vue&type=script&lang=js&"
export * from "./CollectionView.vue?vue&type=script&lang=js&"
import style0 from "./CollectionView.vue?vue&type=style&index=0&id=5dab0192&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dab0192",
  null
  
)

export default component.exports